import React from 'react';
import { Badge, Icon } from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';

/**
 * VerifiedBadge — shown next to a professional's name when an admin has
 * verified their license/details (people.isVerified on the search index).
 */
const VerifiedBadge = ({ isVerified, size = 'sm' }) => {
  if (!isVerified) return null;
  return (
    <Badge
      colorScheme="green"
      display="inline-flex"
      alignItems="center"
      gap={1}
      fontSize={size === 'sm' ? '0.7em' : '0.8em'}
      borderRadius="md"
      px={1.5}
    >
      <Icon as={FaCheckCircle} boxSize={2.5} />
      Verified
    </Badge>
  );
};

export default VerifiedBadge;
